module.exports = __webpack_public_path__ + "img/house.1a6cc376.svg";